(function () {
    'use strict';

    angular.module("imApp").factory("custactGanttService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3781,
                    parameters: parms || {}
                });
            },
            listGantts: function (parms) {
                return $ihttp.post({
                    method: 116,
                    parameters: parms || {}
                });
            },
            saveGantt: function (item) {
                return $ihttp.post({
                    method: 133,
                    parameters: item
                });
            }
        };

        return service;
    }]);
})();
